// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component } from 'react';
import { canPlay } from '../../../constants';
import { defaultProps } from '../props';
import type { BaseReactPlayerProps } from '../types';
import { callPlayer, getSDK } from '../utils';

const SDK_URL = 'https://w.soundcloud.com/player/api.js';
const SDK_GLOBAL = 'SC';

export class SoundCloud extends Component<BaseReactPlayerProps> {
  static defaultProps = defaultProps;

  static canPlay = canPlay.soundcloud;

  static loopOnEnded = true;

  callPlayer = callPlayer;

  duration = null;

  currentTime = null;

  fractionLoaded = null;

  componentDidMount() {
    this.props.onMount?.(this);
  }

  load(url, isReady) {
    getSDK(SDK_URL, SDK_GLOBAL).then((SC) => {
      if (!this.iframe) return;

      const { onReady, onPlay, onPause, onError, onEnded, onSeek, config } =
        this.props;

      const { PLAY, PLAY_PROGRESS, PAUSE, SEEK, FINISH, ERROR } =
        SC.Widget.Events;

      if (!isReady || !this.player) {
        this.player = SC.Widget(this.iframe);
        this.player.bind(PLAY, onPlay);
        this.player.bind(PAUSE, () => {
          const remaining = this.duration - this.currentTime;
          if (remaining < 0.05) {
            // Prevent onPause firing right before onEnded
            return;
          }

          onPause();
        });
        this.player.bind(SEEK, onSeek);
        this.player.bind(PLAY_PROGRESS, (e) => {
          this.currentTime = e.currentPosition / 1000;
          this.fractionLoaded = e.loadedProgress;
        });
        this.player.bind(FINISH, onEnded);
        this.player.bind(ERROR, (e) => onError(e));
      }

      this.player.load(url, {
        ...config.soundcloud.options,
        callback: () => {
          this.player.getDuration((duration) => {
            this.duration = duration / 1000;
            onReady();
          });
        }
      });
    });
  }

  play() {
    this.callPlayer('play');
  }

  pause() {
    this.callPlayer('pause');
  }

  stop() {
    // Nothing to do
  }

  seekTo(seconds, keepPlaying = true) {
    this.callPlayer('seekTo', seconds * 1000);
    if (!keepPlaying) {
      this.pause();
    }
  }

  setVolume(fraction) {
    this.callPlayer('setVolume', fraction * 100);
  }

  mute = () => {
    this.setVolume(0);
  };

  unmute = () => {
    const { volume } = this.props;
    if (volume !== null) {
      this.setVolume(volume);
    }
  };

  getDuration() {
    return this.duration;
  }

  getCurrentTime() {
    return this.currentTime;
  }

  getSecondsLoaded() {
    return this.fractionLoaded * this.duration;
  }

  ref = (iframe) => {
    this.iframe = iframe;
  };

  render() {
    const { url } = this.props;

    const style = {
      width: '100%',
      height: '100%'
    };

    return (
      <iframe
        title="SoundCloud Player"
        ref={this.ref}
        src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}`}
        style={style}
        frameBorder={0}
        allow="autoplay"
      />
    );
  }
}
